module.exports = __webpack_public_path__ + "img/plane-icon-black.276bc926.svg";